import { cx } from "@linaria/core";
import React from "react";

import * as css from "./styles";

type Props = {
  inversed?: boolean;
  vertical?: boolean;
  size?: number;
  color?: string;
  className?: string;
  lineClassName?: string;

  // the width of the chevron line should be defined in intervals of .5px to
  // ensure proper rendering across browsers
  lineWidth?: number;
};

export const Chevron: React.FC<Props> = ({
  className,
  lineClassName,
  vertical,
  inversed,
  color = "currentColor",
  size = 10,
  lineWidth = 2,
}) => {
  // Calculate height of the chevron, using the Pythagorean theorem
  const height = Math.sqrt(size ** 2 * 2);
  const width = height / 2;

  const chevronStyle: React.CSSProperties = {
    height: `${(height + 2).toString()}px`,
    width: `${(width + 2).toString()}px`,
  };

  const lineStyle: React.CSSProperties = {
    width: `${size.toString()}px`,
    height: `${(lineWidth * 2).toString()}px`,
    backgroundColor: color,
    transformOrigin: `calc(100% - ${(lineWidth / 2).toString()}px) 50%`,
  };

  return (
    <i
      className={cx(
        className,
        css.chevronCls,
        inversed && "inversed",
        vertical && "vertical",
      )}
      style={chevronStyle}
    >
      <span
        className={cx(lineClassName, css.lineCls, "upper")}
        style={lineStyle}
      />
      <span
        className={cx(lineClassName, css.lineCls, "lower")}
        style={lineStyle}
      />
    </i>
  );
};
